export var ConditionBlueprintType;
(function (ConditionBlueprintType) {
    ConditionBlueprintType["reflexive"] = "reflexiveCondition";
    ConditionBlueprintType["ageRange"] = "ageRangeCondition";
    ConditionBlueprintType["bmiRange"] = "bmiRangeCondition";
    ConditionBlueprintType["equality"] = "equalityCondition";
    ConditionBlueprintType["emptiness"] = "emptinessCondition";
    ConditionBlueprintType["futureDate"] = "futureDateCondition";
    ConditionBlueprintType["matches"] = "matchesCondition";
    ConditionBlueprintType["matchesRegex"] = "matchesRegexCondition";
    ConditionBlueprintType["numberComparison"] = "numberComparisonCondition";
    ConditionBlueprintType["mathOperator"] = "mathOperator";
    ConditionBlueprintType["lastIncidentDate"] = "lastIncidentDateCondition";
    ConditionBlueprintType["dateComparison"] = "dateComparisonCondition";
    ConditionBlueprintType["characterCountInBetween"] = "characterCountInBetween";
    ConditionBlueprintType["countEqual"] = "countEqual";
    ConditionBlueprintType["percentOf"] = "percentOf";
    ConditionBlueprintType["instancesCount"] = "instancesCount";
    ConditionBlueprintType["jointProductAgeRange"] = "jointProductAgeRange";
    ConditionBlueprintType["engineCondition"] = "engineCondition";
})(ConditionBlueprintType || (ConditionBlueprintType = {}));
export const NumberComparisonConditionOperators = {
    equal: 'equal',
    lessThan: 'lessThan',
    lessThanOrEqual: 'lessThanOrEqual',
    greaterThan: 'greaterThan',
    greaterThanOrEqual: 'greaterThanOrEqual',
    multipleOf: 'multipleOf',
};
export const MathConditionOperators = {
    sum: 'sum',
    subtract: 'subtract',
    multiply: 'multiply',
};
export const MatchesConditionPropertyQuantifiers = {
    any: 'any',
    none: 'none',
};
export const YesNoValues = {
    yes: 'yes',
    no: 'no',
};
export const BlueprintCollectionOperators = {
    thisItem: 'thisItem',
    some: 'some',
    none: 'none',
    every: 'every',
};
export var InstancesCountMethod;
(function (InstancesCountMethod) {
    InstancesCountMethod["addLengthOfArray"] = "addLengthOfArray";
    InstancesCountMethod["addOneIfExists"] = "addOneIfExists";
    InstancesCountMethod["addValue"] = "addValue";
    InstancesCountMethod["addOneIfValueEquals"] = "addOneIfValueEquals";
    InstancesCountMethod["addNumberIfValueEquals"] = "addNumberIfValueEquals";
})(InstancesCountMethod || (InstancesCountMethod = {}));
export function isBlueprintConditionsValue(blueprintConditionsValue) {
    return blueprintConditionsValue && !!blueprintConditionsValue.conditions;
}
